// ConditionalRoute.jsx - Componente para rutas condicionales
import React from 'react';
import { useUsers } from '../metodos/userContext';

//GENERADO Y VERIFICADO CON IA
const ConditionalRoute = ({ tutorComponent: TutorComponent, adminComponent: AdminComponent,  clienteComponent: ClienteComponent , ...props }) => {
  const { usuario } = useUsers();

  if (!usuario) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  // Renderizar componente según el rol
  if (usuario.rol === "TUTOR") {
    return <TutorComponent {...props} />;
  }
  
  if (usuario.rol === "ADMIN" || usuario.rol === "COLABORADOR") {
    return <AdminComponent {...props} />;
  }

  if(usuario.rol === "CLIENTE") {
    return <ClienteComponent {...props} />;
  }

  // Rol no reconocido
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <p className="text-lg font-medium text-red-600">Componente no disponible para tu rol</p>
        <p className="mt-2 text-gray-600">Contacta al administrador</p>
      </div>
    </div>
  );
};

export default ConditionalRoute;